import * as types from '../../mutation-types'
import lazyLoading from './lazyLoading'

const ALLOW_ALL = [1, 2, 3]
const MANAGEMENT = [2, 3]
const ADMIN = [3]
const ALLOW_NONE = []

/**
* show: meta.label -> name
* name: component name
* meta.label: display label
**/
const state = {
  items: [
    {
      name: 'Dashboard',
      path: '/',
      meta: {
        icon: 'fa-tachometer',
        link: 'Home.vue',
        allowed_roles: ALLOW_ALL
      },
      component: lazyLoading('Home', false)
    },
    {
      name: 'projects',
      path: '/project',
      meta: {
        isProject: true,
        auth: true,
        expanded: false,
        icon: 'fa-file',
        link: 'project/index.vue',
        allowed_roles: ALLOW_ALL
      },
      component: lazyLoading('project', true)
    },
    {
      name: 'project',
      path: '/project/:id',
      storeEntry: 'projectmanagement.onderzoek.id',
      meta: {
        auth: true,
        expanded: false,
        needsOnderzoek: true,
        icon: 'fa fa-flask',
        link: 'survey/index.vue',
        allowed_roles: ALLOW_ALL
      },
      component: lazyLoading('survey', true),
      children: [
        {
          name: 'surveyInfo',
          path: 'info',
          meta: {
            label: 'info'
          },
          component: lazyLoading('survey/info', true)
        },
        {
          name: 'asset',
          path: 'asset',
          component: lazyLoading('survey/asset', true)
        },
        {
          name: 'interviews',
          path: 'interviews',
          component: lazyLoading('survey/interviews', true)
        },
        {
          name: 'deskresearch',
          path: 'deskresearch',
          component: lazyLoading('survey/deskresearch', true)
        },
        {
          name: 'beperkingen en uitsluitingen',
          path: 'beperkingen',
          component: lazyLoading('survey/uitsluitingen', true)
        },
        {
          name: 'inventories',
          path: 'inventory',
          component: lazyLoading('survey/inventory', true)
        },
        {
          name: 'sources',
          path: 'sources',
          component: lazyLoading('survey/sources', true)
        },
        {
          name: 'samples',
          path: 'samples',
          component: lazyLoading('survey/samples', true)
        },
        {
          name: 'observations',
          path: 'observations',
          component: lazyLoading('survey/observations', true)
        },
        {
          name: 'certificates',
          path: 'certificates',
          component: lazyLoading('survey/certificates', true)
        },
        {
          name: 'plans',
          path: 'plans',
          component: lazyLoading('survey/plans', true)
        },
        {
          name: 'surveyReports',
          meta: {
            label: 'Rapporten'
          },
          path: 'reports',
          component: lazyLoading('survey/reports', true)
        }
      ]
    },
    {
      name: 'reports',
      path: '/reports',
      meta: {
        icon: 'fa-book',
        expanded: false,
        link: 'reports/index.vue',
        auth: true,
        allowed_roles: MANAGEMENT
      },
      component: lazyLoading('reports', true),
      children: [
        {
          name: 'templates',
          path: 'template_editor',
          meta: {
            link: 'templateEditor/index.vue',
            label: 'Templates'
          },
          component: lazyLoading('reports/templateEditor', true)
        },
        {
          name: 'elements',
          path: 'element_editor',
          meta: {
            link: 'elementEditor/index.vue',
            label: 'Elements'
          },
          component: lazyLoading('reports/elementEditor', true)
        }
      ]
    },
    {
      name: 'VSCP templates',
      path: '/vscptemplates',
      meta: {
        auth: true,
        expanded: false,
        icon: 'fa-copy',
        link: 'vscptemplates/index.vue',
        allowed_roles: process.env.APP_NAME?.toLowerCase() === 'maritime' ? ALLOW_ALL : ALLOW_NONE
      },
      component: lazyLoading('vscptemplates', true)
    },
    {
      name: 'assetmanagement',
      path: '/assetmanagement',
      meta: {
        auth: true,
        expanded: false,
        icon: 'fa-home',
        link: 'assetmanagement/index.vue',
        allowed_roles: process.env.APP_NAME?.toLowerCase() === 'maritime' ? ALLOW_NONE : ALLOW_ALL
      },
      component: lazyLoading('assetmanagement', true),
      children: [
        {
          name: 'assets',
          path: 'assets',
          meta: {
            auth: true,
            link: 'assets/index.vue'
          },
          component: lazyLoading('assetmanagement/assets', true)
        },
        {
          name: 'Pand sjablonen',
          path: 'asset_templates',
          meta: {
            auth: true,
            link: 'ruimteTemplates/index.vue'
          },
          component: lazyLoading('assetmanagement/ruimteTemplates', true)
        }
      ]
    },
    {
      name: 'vesselmanagement',
      path: '/vesselmanagement',
      meta: {
        auth: true,
        expanded: false,
        icon: 'fa-ship',
        link: 'vesselmanagement/index.vue',
        allowed_roles: process.env.APP_NAME?.toLowerCase() === 'maritime' ? ALLOW_ALL : ALLOW_NONE
      },
      component: lazyLoading('vesselmanagement', true),
      children: [
        {
          name: 'Vessels',
          path: 'vessels',
          meta: {
            auth: true,
            link: 'vessels/index.vue'
          },
          component: lazyLoading('vesselmanagement/vessels', true)
        },
        {
          name: 'Vessel templates',
          path: 'vessel_templates',
          meta: {
            auth: true,
            link: 'ruimteTemplates/index.vue'
          },
          component: lazyLoading('vesselmanagement/ruimteTemplates', true)
        }
      ]
    },
    {
      name: 'organisation',
      path: '/organisation',
      meta: {
        icon: 'fa-building',
        auth: true,
        expanded: false,
        link: 'organisation/index.vue',
        allowed_roles: MANAGEMENT
      },
      component: lazyLoading('organisation', true),
      children: [
        {
          name: 'organisationInfo',
          path: 'info',
          meta: {
            link: 'info/index.vue',
            label: 'info'
          },
          component: lazyLoading('organisation/info', true)
        },
        {
          name: 'users',
          path: 'users',
          meta: {
            link: 'users/index.vue'
          },
          component: lazyLoading('organisation/users', true)
        },
        {
          name: 'clients',
          path: 'clients',
          meta: {
            link: 'clients/index.vue'
          },
          component: lazyLoading('organisation/clients', true)
        },
        {
          name: 'laboratories',
          path: 'laboratories',
          meta: {
            link: 'laboratories/index.vue'
          },
          component: lazyLoading('organisation/laboratories', true)
        }
      ]
    },
    {
      name: 'variables',
      path: '/variables',
      meta: {
        icon: 'fa-table',
        link: 'variables/index.vue',
        auth: true,
        allowed_roles: ADMIN
      },
      component: lazyLoading('variables', true)
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index]?.meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}
